import graphql__127ce1b981fc8be55817 from "./__generated__/ParticipativeModuleResultsFormFields_pageSection.graphql.js";
import graphql__4704a75af8a193be803f from "./__generated__/ParticipativeModuleResultsFormFieldsQuery.graphql.js";import { useState } from "react";
import {
  graphql,
  useFragment,
  useLazyLoadQuery,
  useSubscribeToInvalidationState
} from "react-relay";

import ParticipativeModuleResultsFormField from "./index";

const ParticipativeModuleResultsFormFields = props => {
  const { pageSection: inputSection, ...passthroughProps } = props;
  const pageSection = useFragment(
    ParticipativeModuleResultsFormFields_pageSection,
    inputSection
  );
  const { id: pageSectionId, participativeModuleIds } = pageSection;

  // The fetchKey allows us to trigger a re-fetch of the results when the invalidation
  // state of the participative modules changes, and also avoid re-fetching the results
  // when nothing has changed while the component is still mounted.
  //
  const [fetchKey, setFetchKey] = useState(0);

  const data = useLazyLoadQuery(
    ParticipativeModuleResultsFormFieldsQuery,
    { pageSectionId },
    { fetchKey, fetchPolicy: "network-only" }
  );

  // Whenever a related participative module is invalidated, increment the version to
  // trigger a refetch of the results and re-render the result data.
  useSubscribeToInvalidationState(participativeModuleIds, () => {
    setFetchKey(prevKey => prevKey + 1);
  });

  if (!data) return null;

  const { results } = data;

  return (
    <>
      {results.map(result => (
        <ParticipativeModuleResultsFormField
          {...passthroughProps}
          key={result.id}
          result={result}
        />
      ))}
    </>
  );
};

const ParticipativeModuleResultsFormFields_pageSection = graphql__127ce1b981fc8be55817;

const ParticipativeModuleResultsFormFieldsQuery = graphql__4704a75af8a193be803f;

export default ParticipativeModuleResultsFormFields;
